import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import rootReducer from "./store";
import { PDFViewer } from "@react-pdf/renderer";

import { BrowserRouter as Router } from "react-router-dom";

// function DesktopOnlyOverlay() {
//   return (
//     <div className="fixed inset-0 z-100 flex items-center justify-center bg-surface-primary-dashboard lg:hidden">
//       <div className="max-w-sm px-6 text-center">
//         <h1 className="mb-3 text-xl font-semibold text-heading-5">
//           Desktop required
//         </h1>
//         <p className="text-sm text-body">
//           This admin application is optimized for desktop screens. Please open
//           it on a desktop or laptop for the complete experience.
//         </p>
//       </div>
//     </div>
//   );
// }
const composeEnhancer =
  (window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const store = createStore(rootReducer, composeEnhancer(applyMiddleware(thunk)));

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <Router>
    <Provider store={store}>
      {/* <DesktopOnlyOverlay /> */}
      <App />
    </Provider>
  </Router>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
